import React, { useEffect, useState } from 'react';
import { SecretsTeaser } from './HelpModal';

// A one-time invitation to hunt for the secrets: it slides in a little while after the gallery first
// shows, stays for a few seconds, and is remembered in this browser so it never nags. Tapping it
// opens the guide.
const SEEN_KEY = 'gallery-secrets-hint';
const DELAY_MS = 20000, SHOW_MS = 12000;

const SecretsHint = ({ active, onOpenHelp }) => {
  const [show, setShow] = useState(false);
  useEffect(() => {
    if (!active) return undefined;
    let seen = false;
    try { seen = !!localStorage.getItem(SEEN_KEY); } catch (e) { /* private mode: show it */ }
    if (seen) return undefined;
    const t1 = setTimeout(() => {
      setShow(true);
      try { localStorage.setItem(SEEN_KEY, '1'); } catch (e) { /* ignore */ }
    }, DELAY_MS);
    const t2 = setTimeout(() => setShow(false), DELAY_MS + SHOW_MS);
    return () => { clearTimeout(t1); clearTimeout(t2); };
  }, [active]);
  if (!show) return null;
  return (
    <button
      type="button"
      onClick={() => { setShow(false); onOpenHelp?.(); }}
      className="fixed top-16 md:top-4 left-1/2 -translate-x-1/2 z-[55] w-[min(calc(100vw-130px),460px)] text-left fade-in"
      aria-label="This gallery hides secrets. Open the guide"
    >
      <SecretsTeaser />
    </button>
  );
};

export default SecretsHint;
